(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
$(document).ready(function () {
  jQuery(document).ready(function($) {
  $('li.menu-item.has-dropdown > a').attr('href', 'javascript:;');
});
  const $submenuItems = $('.submenu-item');
  const $firstItem = $('.submenu-item.first-default');

  $submenuItems.on('mouseenter', function () {
    if (!$(this).hasClass('first-default')) {
      $firstItem.removeClass('first-default');
    }
  });

  $submenuItems.on('mouseleave', function () {
    const isAnyHovered = $submenuItems.toArray().some(el =>
      $(el).is(':hover') && !$(el).hasClass('first-default')
    );

    if (!isAnyHovered) {
      $firstItem.addClass('first-default');
    }
  });

const $menuItems = $('.header-menu .main-menu > li, .mobile-menu-links .main-menu > li');

$menuItems.on('click', function(e) {
  // Don't propagate to document click handler
  e.stopPropagation();
  
  const $dropdown = $(this).find('.dropdown-menu');
  const wasOpen = $dropdown.hasClass('opendropdown');
  
  // Close all other open dropdowns first
  $('.dropdown-menu.opendropdown').not($dropdown).removeClass('opendropdown');
  
  // Toggle this dropdown based on its previous state
  $dropdown.toggleClass('opendropdown', !wasOpen);
});

// Click outside to close dropdowns
$(document).on('click', function() {
  $('.dropdown-menu.opendropdown').removeClass('opendropdown');
});

// Prevent dropdown from closing when clicking inside it
$('.dropdown-menu').on('click', function(e) {
  e.stopPropagation();
});

let isHoveringDropdown = false;

$('.dropdown-menu').on('mouseenter', function () {
  isHoveringDropdown = true;
});

$('.dropdown-menu').on('mouseleave', function () {
  isHoveringDropdown = false;

  // Use a small delay to allow checking if the mouse entered another dropdown
  setTimeout(function () {
    if (!isHoveringDropdown) {
      $('.dropdown-menu.opendropdown').removeClass('opendropdown');
    }
  }, 100);
});


  
});

$(document).ready(function () {
  const $trigger = $('.header__icon--lang-country');
  const $modal = $('.header-country-modal');
  const $modalContent = $('.header-country-modal-content');
  const $closeBtn = $('.header-country-modal-close');

  // Open modal
  $trigger.on('click', function (e) {
    e.preventDefault();
    $modal.addClass('open');
  });

  // Close on clicking the close button
  $closeBtn.on('click', function () {
    $modal.removeClass('open');
  });

  // Close when clicking outside modal content
  $(document).on('click', function (e) {
    if (
      $modal.hasClass('open') &&
      !$modalContent.is(e.target) &&
      $modalContent.has(e.target).length === 0 &&
      !$trigger.is(e.target) &&
      $trigger.has(e.target).length === 0
    ) {
      $modal.removeClass('open');
    }
  });
});

$(document).ready(function () {
  // Show customer login when .customer-modal is clicked
  $('.customer-modal').on('click', function (e) {
    e.stopPropagation(); // Prevent event from bubbling to document
    $('.customer-login').slideToggle();
  });

  // Hide customer login when clicking outside of it
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.customer-login, .customer-modal').length) {
      $('.customer-login').slideUp();
    }
  });

  // Prevent hiding when clicking inside .customer-login
  $('.customer-login').on('click', function (e) {
    e.stopPropagation();
  });
});

$(document).ready(function() {
  // When menu-open button is clicked
  $('.menu-open').on('click', function(e) {
    e.preventDefault(); // Prevent default action if it's a link
    $('.mobile-menu').addClass('openmenu');
    // Optional: disable body scroll when menu is open
    $('body').addClass('menu-open-no-scroll');
  });

  // When mobile-menu-close button is clicked
  $('.mobile-menu-close').on('click', function(e) {
    e.preventDefault(); // Prevent default action if it's a link
    $('.mobile-menu').removeClass('openmenu');
    // Optional: re-enable body scroll when menu is closed
    $('body').removeClass('menu-open-no-scroll');
  });

  // Optional: Close menu when clicking outside of it
  $(document).on('click', function(e) {
    if (!$(e.target).closest('.mobile-menu').length && !$(e.target).closest('.menu-open').length) {
      $('.mobile-menu').removeClass('openmenu');
      $('body').removeClass('menu-open-no-scroll');
    }
  });

  // Optional: Close menu when pressing ESC key
  $(document).on('keyup', function(e) {
    if (e.key === "Escape") {
      $('.mobile-menu').removeClass('openmenu');
      $('body').removeClass('menu-open-no-scroll');
    }
  });
});


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
